import dayjs from 'dayjs';

/**
 * Returns the number of milliseconds since the Unix Epoch 
 * @example
 * getUnixTimestampInMs('2019-01-25') // 1548363600000
 */
export function getUnixTimestampInMs (date: string): number {
  return dayjs(date).valueOf();
}